

const getWeatheraToTW = async() => {
    let data = await fetch('https://oceanracingleague.com/game/getWeeklyTraits.php');
    let res = await data.json();
    return res;
}

const getAccountDetails = async(address) => {
    let data = await fetch('https://oceanracingleague.com/game/check.php?a=' + address);
    let res = await data.json();
    return res;
}

const setName = async(name, shortName, address, league) => {
    let data = await fetch('https://oceanracingleague.com/game/setName.php?name=' + name + '&accname=' + shortName + '&addr=' + address + '&league=' + league);
    let res = await data.json();
    console.log(res);
    return res.result;
}

const getRacerDetails = async() => {
    let data = await fetch('https://oceanracingleague.com/game/crawlnew.php');
    let res = await data.json();
    return res.result;
}

const getCoachDetails = async() => {
    let data = await fetch('https://oceanracingleague.com/game/coachCrawlNew.php');
    let res = await data.json();
    return res.result;
}

const getWeeks = async() => {
    let data = await fetch('https://oceanracingleague.com/game/getWeeksNew.php');
    let res = await data.json();
    return res;
}

const getLeaderBoard = async(week,seasononly) => {
    let data = await fetch('https://oceanracingleague.com/game/getLeaderboardNew.php?a=' + week + '&b=' + seasononly);
    let res = await data.json();
    console.log(res);
    return res;
}

const getLobby = async(week) => {
    let data = await fetch('https://oceanracingleague.com/game/getLobbyDataNew.php?b=' + week);
    let res = await data.json();
    return res;
}

const getRecords= async () => {

    let data = await fetch('https://oceanracingleague.com/game/getRaceRecords.php');
    const txtData = await data.json();
    return txtData;

}

const removeLookingFor = async(walletAddress, id) => {
    let data = await fetch('https://oceanracingleague.com/game/searchableRacers.php?addr=' + walletAddress + '&type=remlv&searchid=' + id);
    const jsonData = await data.json();
    return jsonData;
}

const getLookingForSearches = async(walletAddress) => {
    let data = await fetch('https://oceanracingleague.com/game/lookingForInfo.php?addr=' + walletAddress);
    const jsonData = await data.json();
    return jsonData;
}

const addLookingForSearches = async(walletAddress, creature, skin) => {
    let data = await fetch('https://oceanracingleague.com/game/searchableRacers.php?addr=' + walletAddress + '&type=addlf&creature=' + creature + '&skin=' + skin);
    const jsonData = await data.json();
    return jsonData;
}

const updateLookingForSearchable = async(walletAddress, checked) => {
    let data = await fetch('https://oceanracingleague.com/game/searchableRacers.php?addr=' + walletAddress + '&type=updatesearchable&allow=' + checked);
    const jsonData = await data.json();
    return jsonData;
}

const getTeamDetails = async(walletAddress) => {
    let data = await fetch('https://oceanracingleague.com/game/getWalletsToTransfer.php?addr=' + walletAddress);
    const jsonData = await data.json();
    return jsonData;
}

const updateHiLo = async(walletAddress, league, status) => {
    let data = await fetch("https://oceanracingleague.com/game/setHiLo.php?a=" + walletAddress + "&league=" + league + "&c=" + status);
	const resp = await data.text();
	return resp;				
}

const getCoachLeaderboard = async(walletAddress) => {
    let data = await fetch('https://oceanracingleague.com/game/getCoachContestLeaders.php');
    const jsonData = await data.json();
    return jsonData;
}

const registerAccount = async(walletAddress, signature) => {
    let data = await fetch("https://oceanracingleague.com/game/register.php?rose=" + walletAddress + "&coffer=" + walletAddress + "&hancock=" + signature);
    const resp = await data.text();
    return resp;
}

const getPreviouslyRaced = async(walletAddress, league) => {
    let data = await fetch('https://oceanracingleague.com/game/getPreviouslyRaced.php?team=' + walletAddress + '&league=' + league);
    const jsonData = await data.json();
    return jsonData.prevracers;
}

export {getWeatheraToTW, getAccountDetails, setName, getRacerDetails, getCoachDetails, getWeeks, getLeaderBoard, getLobby, getRecords, removeLookingFor,getLookingForSearches,addLookingForSearches,updateLookingForSearchable, getTeamDetails, updateHiLo, getCoachLeaderboard, registerAccount, getPreviouslyRaced}